import { createFileRoute, Outlet } from "@tanstack/react-router";

import { PermissionGuard } from "~/components/permission-guard";
import { ensureSession } from "~/modules/auth/credentials";

export const Route = createFileRoute("/_dash/videos")({
  component: RouteComponent,
  beforeLoad() {
    // videos requires a justification session
    ensureSession();
  },
});

function RouteComponent() {
  return (
    <PermissionGuard permission="mirage-videos:view">
      <Outlet />
    </PermissionGuard>
  );
}
